import { capitalizeString, splitSnakeCase } from "util/Utils";

// Preset alert bundles applied server-side when subscribing with "usePresetAlerts" /
// "usePresetAdminAlerts". These mirror alert_helpers.py (PRESET_STAFF_ALERTS /
// PRESET_ADMIN_ALERTS) and are used only to preview which alerts a preset includes;
// the backend remains the source of truth for what actually gets created.
export const PRESET_STAFF_ALERTS = [
  "tablet_not_polling",
  "printer_not_polling",
  "station_disallowed_ordering",
  "order_unopened_for_4_minutes",
  "order_unopened_for_8_minutes",
];

export const PRESET_ADMIN_ALERTS = [
  "tablet_not_polling",
  "printer_not_polling",
  "station_disallowed_ordering",
  "order_unopened_for_10_minutes",
];

const PRESET_ALERT_LABELS = {
  tablet_not_polling: "Tablet not polling",
  printer_not_polling: "Printer not polling",
  station_disallowed_ordering: "Station disallowed ordering",
  order_unopened_for_4_minutes: "Order left unopened for 4 minutes",
  order_unopened_for_8_minutes: "Order left unopened for 8 minutes",
  order_unopened_for_10_minutes: "Order left unopened for 10 minutes",
};

// Human-readable label for a preset alert class, with a snake-case fallback for anything
// not explicitly mapped so a backend addition never renders a blank line.
export const describePresetAlert = (alertClass) =>
  PRESET_ALERT_LABELS[alertClass] || capitalizeString(splitSnakeCase(alertClass));

// Alert-type label dictionaries for the custom alert builder, split by channel so the
// "Add an alert" dropdown can be filtered to what a recipient's contact methods support.
export const PHONE_ALERT_MAP = {
  order_unopened: "SMS: Order Left Unopened",
  printer_not_polling: "SMS: Printer Not Polling",
  tablet_not_polling: "SMS: Tablet Not Polling",
  station_disallowed_ordering: "SMS: Tablet Disallowed Ordering",
  robot_not_polling: "SMS: Robot Not Polling",
  robot_problem: "SMS: Robot Problem",
};

export const EMAIL_ALERT_MAP = {
  order_received_email: "Email: Order Received",
  catering_order_unopened: "Email: Order Left Unopened",
  email_catering_order_in: "Email: Order Due",
};

export const ALERT_LABELS = { ...PHONE_ALERT_MAP, ...EMAIL_ALERT_MAP, all: "SMS + Email: All Alerts" };

// Trigger-time option lists for the per-alert editor.
export const CATERING_UNOPENED_HOURS_OPTIONS = [1, 2, 3, 4, 5, 6].map((num) => ({
  label: `${num} Hours`,
  value: num.toString(),
}));

export const EMAIL_DUE_OPTIONS = [
  { label: "4 Hours", value: "4hours" },
  { label: "30 Minutes", value: "30minutes" },
];

export const ORDER_UNOPENED_MINUTES_OPTIONS = [2, 3, 5, 10, 15, 20, 30].map((num) => ({
  label: `${num} Minutes`,
  value: num.toString(),
}));
